<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-11",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 11,
      nextPage: '/questionnaire/section2',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Pregnancy.png'),
        mainTitle: 'Do you have any of the following conditions?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Bleeding gums',
            },{
              text: 'Vomition of pregnancy',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
